module.exports = __webpack_public_path__ + "img/m-hd.80f5a74d.webp";